import React from 'react';
import './noData.scss';
import { useTranslation } from 'react-i18next';
import { Icon, NonIdealState } from '@blueprintjs/core';

export const NoData = function() {
  const { t } = useTranslation();

  return <NonIdealState className='noData' icon={<Icon icon='error' iconSize={40}/>} title={t('dashboard.viz.noData')}/>;
};